export default __webpack_public_path__ + "static/media/CNo.90-6.1443b5b3.jpg";